var unitPrice = "{{ pricePerUnit }} kpl";
var unitsCount = "{{ unitsCount }} kappaletta";
var unitCount = "{{ unitsCount }} kappale";
var unitPriceWithQuantity = "{{ pricePerUnit }} kpl / {{ unitsCount }} kappaletta";
var vatInclusive = "sis. ALV";
var vatExclusive = "Ei sis. ALV";
var excludeShipping = "Ei sis. {{ shipping }}";
var includeShipping = "Sis. {{ shipping }}";
var shipping = "toimitus";
var vatAndShipping = {
	includeVatExcludeShipping: "Sis. ALV, ei sis. {{ shipping }}",
	excludeVatIncludeShipping: "Ei sis. ALV. sis. {{ shipping }}",
	includeVatIncludeShipping: "Sis. ALV, sis. {{ shipping }}",
	excludeVatExcludeShipping: "Sis. ALV, ei sis. {{ shipping }}"
};
var priceSummary = "Hintojen yhteenveto";
var priceSummaryInfoIcon = "Hintayhteenvedon infokuvake";
var priceSummaryModal = "Hintayhteenvetomodaali";
var priceSummaryCloseModal = "Sulje hintayhteenveto -modaali";
var priceSummaryTermsAndConditions = "* Jokaista tilausta varten tehdään yksilöllinen seula tai tyyny, ja laitteisto sovitetaan suunnittelemasi mallin painamista varten. ";
var priceSummaryBasePrice = "Perushinta";
var priceSummarySetupFee = "Mukautusmaksu*";
var priceSummarySubtotal = "Välisumma";
var differentialPrice = {
	included: "Sisältyy mukaan",
	forUnits: "{{ differentialPrice }}/{{ quantity }} kpl",
	forUnit: "{{ differentialPrice }}/{{ quantity }} kpl"
};
var priceFrom = "Lähettäjä: {{ price }}";
var priceFromEach = "Alkaen {{ price }} / kpl";
var volumeDiscount = "{{volumeDiscount}} % määräalennus";
var volumeDiscountPlusSale = "{{volumeDiscount}} % määräalennus + ale";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} per kpl";
var originalPrice = "alkuperäinen hinta:";
var salePrice = "nykyinen alennushinta:";
var setupFee = "Mukautusmaksu {{ setupFee }}";
var noSetupFee = "Ei mukautusmaksua";
var vatAndSetupFee = {
	noVatInclSetup: "Sisältää {{ setupFee }} mukautusmaksun",
	inclVatAndSetup: "Sisältää {{ setupFee }} mukautusmaksun ja ALV:n",
	exclVatInclSetup: "Sisältää {{ setupFee }} mukautusmaksun, ei sis. ALV",
	inclVatSetupInclShipping: "Sisältää {{ setupFee }} mukautusmaksun ja ALV:n, sis. {{ shipping }}",
	inclVatSetupExclShipping: "Sisältää {{ setupFee }} mukautusmaksun ja ALV:n, ei sis. {{ shipping }}",
	exclVatSetupInclShipping: "Sisältää {{ setupFee }} mukautusmaksun, ei sis. ALV, sis. {{ shipping }}",
	exclVatSetupExclShipping: "Sisältää {{ setupFee }} mukautusmaksun, ei sis. ALV eikä {{ shipping }}"
};
var priceFor = "{{ quantity }}/{{ price }}";
var fifi = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { fifi as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
